import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; 
import "./CustomToastStyles.css"; 
import Header from "./Header.js";
import useAuth from './useAuth';
import Sidebar from "./Sidebar.js";
import Footer from "./Footer.js";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Edit_Vehicle_Drivers() {
    useAuth();
    const navigate = useNavigate();
    const { id } = useParams();

    // State
    const [formData, setFormData] = useState({
        fname: "",
        lname: "",
        emp_code: "",
        mobile: "",
        licence_number: "",
        licence_type: "",
        licence_from_date: "",
        licence_to_date: "",
        id: id,
    });

    const [loading, setLoading] = useState(false);

    // Fetch Data
    useEffect(() => {
        fetchDetails();
    }, [id]);

    const fetchDetails = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                toast.error("Authentication error. Please log in.");
                return;
            }

            const response = await fetch(`${API_BASE_URL}getVehicleDriverById/${id}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                }
            });

            const result = await response.json();
            if (result.status && result.data) {
                setFormData({
                    fname: result.data.fname || "",
                    lname: result.data.lname || "",
                    emp_code: result.data.emp_code || "",
                    mobile: result.data.mobile || "",
                    licence_number: result.data.licence_number || "",
                    licence_type: result.data.licence_type || "",
                    licence_from_date: result.data.licence_from_date || "",
                    licence_to_date: result.data.licence_to_date || "",
                    id: id
                });
            } else {
                toast.error(result.message || "Error fetching driver details.");
            }
        } catch (error) {
            console.error("Fetch error:", error);
            toast.error("Failed to fetch data");
        } finally {
            setLoading(false);
        }
    };

    // Handle Form Changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    // Form Validation
    const validateFormData = () => {
        const { fname, lname, emp_code, mobile, licence_number } = formData;
        if (!fname || !lname || !emp_code || !mobile || !licence_number) {
            toast.error("All fields are required.");
            return false;
        }
        return true;
    };

    // Handle Submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateFormData()) return;

        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                toast.error("Authentication error. Please log in.");
                return;
            }

            const response = await fetch(`${API_BASE_URL}updateVehicleDriver/${id}`, {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            if (result.status) {
                toast.success("Vehicle Driver successfully updated");
                setTimeout(() => navigate("/manage_vehicle_drivers"), 2000);
            } else {
                toast.error(result.message || "Error updating driver details.");
            }
        } catch (error) {
            console.error("Fetch error:", error);
            toast.error("Failed to update driver details.");
        }
    };

    if (loading) {
        return (
            <div className="content-wrapper d-flex justify-content-center align-items-center">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div className='hold-transition sidebar-mini layout-fixed'>
            <div className='wrapper'>
                <Header />
                <Sidebar />

                <div className='content-wrapper'>
                    <div className='content-header'>
                        <div className='container-fluid'>
                            <div className='row mb-2'>
                                <div className='col-sm-6'>
                                    <h1 className='m-0'>Edit Vehicle Driver</h1>
                                </div>
                                <div className='col-sm-6'>
                                    <ol className='breadcrumb float-sm-right'>
                                        <li className='breadcrumb-item'><a href='#'>Home</a></li>
                                        <li className='breadcrumb-item active'>Edit Vehicle Driver</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className='col-lg-12'>
                        <div className='card' style={{ borderTop: "3px solid #00c0ef" }}>
                            <div className='card-body'>
                                <form onSubmit={handleSubmit} method='post'>
                                    <div className='row'>
                                        <div className='form-group col-md-3'>
                                            <label>First Name <span style={{ color: "red" }}>*</span></label>
                                            <input type='text' name='fname' value={formData.fname} onChange={handleChange} className="form-control input-font" />
                                        </div>

                                        <div className='form-group col-md-3'>
                                            <label>Last Name <span style={{ color: "red" }}>*</span></label>
                                            <input type='text' name='lname' value={formData.lname} onChange={handleChange} className="form-control input-font" />
                                        </div>

                                        <div className='form-group col-md-3'>
                                            <label>BMID <span style={{ color: "red" }}>*</span></label>
                                            <input type='number' name='emp_code' value={formData.emp_code} onChange={handleChange} className="form-control input-font" />
                                        </div>

                                        <div className='form-group col-md-3'>
                                            <label>Mobile <span style={{ color: "red" }}>*</span></label>
                                            <input type='number' name='mobile' value={formData.mobile} onChange={handleChange} className="form-control input-font" />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className='form-group col-md-3'>
                                            <label>Licence Number</label>
                                            <input type='text' name='licence_number' placeholder="Enter Licence Number" value={formData.licence_number} onChange={handleChange} className="form-control input-font" />
                                        </div>

                                        <div className='form-group col-md-3'>
                                            <label>Licence Type</label>
                                            <select name='licence_type' value={formData.licence_type} onChange={handleChange} className="form-control input-font">
                                                <option value="">Select Licence Type</option>
                                                <option value="Two Wheeler">Two Wheeler</option>
                                                <option value="Four Wheeler">Four Wheeler</option>
                                                <option value="Heavy Vehicle">Heavy Vehicle</option>
                                            </select>
                                        </div>

                                        <div className='form-group col-md-3'>
                                            <label>Licence From Date</label>
                                            <input type='date' name='licence_from_date' value={formData.licence_from_date} onChange={handleChange} className="form-control input-font" />
                                        </div>

                                        <div className='form-group col-md-3'>
                                            <label>Licence To Date</label>
                                            <input type='date' name='licence_to_date' value={formData.licence_to_date} onChange={handleChange} className="form-control input-font" />
                                        </div>
                                    </div>

                                    <button type='submit' className='btn btn-success'>Submit</button>
                                </form>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer />
                <ToastContainer />
            </div>
        </div>
    );
}

export default Edit_Vehicle_Drivers;
